import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { retry } from 'rxjs/operators';

import type {
  UpdateInstanceDto,
  InstanceDto,
  StatusCountsDto,
  UpdateInstanceResponse,
} from '@plugins/faq-lib/types';

@Injectable({
  providedIn: 'root',
})
export class InstanceService {
  private readonly http = inject(HttpClient);

  load() {
    return this.http
      .get<InstanceDto>('/api/instance')
      .pipe(retry({ delay: 7000 }));
  }

  update(instance: UpdateInstanceDto) {
    return this.http.patch<UpdateInstanceResponse>('/api/instance', instance);
  }

  countByStatus() {
    return this.http.get<StatusCountsDto>('/api/question/status');
  }
}
